(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(70417);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBreakpoints; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var BREAKPOINTS = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xl2: false
};
function useBreakpoints() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
        xs: true
    })), breakpoint = ref[0], setBreakpoint = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        var updateSize = function updateSize() {
            var w = window.innerWidth;
            if (w <= 640) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                xs: true
            }));
            else if (w <= 768) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                sm: true
            }));
            else if (w <= 1024) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                md: true
            }));
            else if (w <= 1280) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                lg: true
            }));
            else if (w <= 1536) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                xl: true
            }));
            else setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                xl2: true
            }));
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return function() {
            return window.removeEventListener("resize", updateSize);
        };
    }, []);
    return breakpoint;
};


/***/ }),

/***/ 70417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 21 modules
var base_ui = __webpack_require__(86481);
// EXTERNAL MODULE: ./src/features/webpage/index.js + 6 modules
var webpage = __webpack_require__(12068);
// EXTERNAL MODULE: ./src/features/base-ui/Utility.js
var Utility = __webpack_require__(12774);
// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./src/hooks/useBreakpoints.js
var useBreakpoints = __webpack_require__(22807);
;// CONCATENATED MODULE: ./src/hooks/index.js


// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 1 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(30511);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/layouts/Layout.js
var Layout = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(42763);
// EXTERNAL MODULE: ./src/features/webpage/LoginBox.jsx
var LoginBox = __webpack_require__(71879);
// EXTERNAL MODULE: ./src/features/webpage/EditorTypography.jsx
var EditorTypography = __webpack_require__(18995);
;// CONCATENATED MODULE: ./src/pages/index.js








// import DateView from '../panel/lib/components/DateView'







// import { text } from 'micro'
function Homepage(param) {
    var pageData = param.pageData, footerData = param.footerData, contactData = param.contactData, brokers = param.brokers;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var breakpoint = (0,useBreakpoints/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var setData = (0,dataProvider/* useDataProvider */.x5)().setData;
    var sections = pageData === null || pageData === void 0 ? void 0 : pageData.sections;
    (0,react.useEffect)(function() {
        setData({
            homeNav: true,
            footerData: footerData,
            contactData: contactData
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-image:url('/img/home/hero/moment-discussion-1.jpg');background-size:cover;height:", breakpoint.xl ? "36rem" : "45rem", ";display:flex;align-items:center;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "flex items-center justify-center lg:ml-60 2xl:mt-24 xl:pl-32 xl:pt-20 px-4 lg:px-2 xl:px-0 md:container mx-auto",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)((0,Utility/* MediaQuery */.zP)("lg", "max"), "{order:1;};"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                    type: "h1",
                                    color: "secondary",
                                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {text-align: center;} text-shadow: 1px 1px 2px ").concat(theme.colors.lighterGray, "; "),
                                    children: sections === null || sections === void 0 ? void 0 : (ref = sections[0]) === null || ref === void 0 ? void 0 : ref.title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                    type: "h3",
                                    color: "secondary",
                                    className: "pt-6",
                                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {text-align: center;} text-shadow: 1px 1px 2px ").concat(theme.colors.lighterGray, ";"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "dynamic-content",
                                        dangerouslySetInnerHTML: {
                                            __html: sections === null || sections === void 0 ? void 0 : (ref1 = sections[0]) === null || ref1 === void 0 ? void 0 : ref1.content
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "flex flex-wrap justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                            backgroundColor: "secondary",
                                            color: "lighterGray",
                                            className: "mt-10 ml-6",
                                            style: "padding: 0.5rem 1.5rem; box-shadow: none; border:1px solid #0000007a;",
                                            onClick: function() {
                                                router.push("/about");
                                            },
                                            children: t("how does it work?")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                            backgroundColor: "primary",
                                            color: "secondary",
                                            className: "mt-10 ml-6",
                                            style: "padding: 0.5rem 1.5rem; box-shadow: none; border:1px solid #0000007a;",
                                            onClick: function() {
                                                router.push("/about");
                                            },
                                            children: t("what is rebate?")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Section */.$0, {
                backgroundImage: "/img/svg/Background-mountain.svg",
                style: "background-position: bottom;",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "grid lg:grid-cols-2 content-center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "order-2 lg:order-2 mt-20 lg:mt-0",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                                    color: "text",
                                    highlight: "فارکس ریبیت",
                                    imgSrc: "/img/svg/title-line.svg",
                                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                                    children: sections === null || sections === void 0 ? void 0 : (ref2 = sections[1]) === null || ref2 === void 0 ? void 0 : ref2.title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                    type: "p",
                                    className: "pt-6",
                                    lineHeight: "2rem",
                                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {text-align: center;}"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "dynamic-content",
                                        dangerouslySetInnerHTML: {
                                            __html: sections === null || sections === void 0 ? void 0 : (ref3 = sections[1]) === null || ref3 === void 0 ? void 0 : ref3.content
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "order-1 lg:order-2 pb-10 w-full md:w-96",
                            /* eslint-disable indent */ css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-radius:", theme.borderRadius.default, ";height:fit-content;width:", breakpoint.lg && "25rem" || breakpoint.xl2 && "30rem", ";background-color:", theme.colors.mainBackground, ";justify-self:center;margin-top:-8rem;box-shadow:", theme.boxShadow.md, ";"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginBox/* default */.Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Section */.$0, {
                backgroundImage: "/img/home/how/home-how-background.jpg",
                parallax: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "grid lg:grid-cols-2 content-center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                                    color: "lighterGray",
                                    highlight: "چه طور",
                                    imgSrc: "/img/svg/title-line.svg",
                                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                                    children: sections === null || sections === void 0 ? void 0 : (ref4 = sections[2]) === null || ref4 === void 0 ? void 0 : ref4.title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                    type: "p",
                                    color: "lighterGray",
                                    className: "pt-6",
                                    style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {text-align: center;}"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "dynamic-content",
                                        dangerouslySetInnerHTML: {
                                            __html: sections === null || sections === void 0 ? void 0 : (ref5 = sections[2]) === null || ref5 === void 0 ? void 0 : ref5.content
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                    backgroundColor: "primary",
                                    color: "secondary",
                                    className: "mt-4 lg:mr-0 mx-auto",
                                    onClick: function() {
                                        router.push("/about#how-does-forexrebate-work");
                                    },
                                    children: t("more info")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "self-center justify-self-center",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                alt: "chart svg",
                                src: "/img/home/how/Payment-TRANSPARRENT.png",
                                width: "400",
                                height: "400"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
                backgroundImage: "/img/home/start/bg-rate.svg",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                        color: "text",
                        highlight: "شروع کنید",
                        imgSrc: "/img/svg/title-line.svg",
                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                        children: sections === null || sections === void 0 ? void 0 : (ref6 = sections[3]) === null || ref6 === void 0 ? void 0 : ref6.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "grid lg:grid-cols-3 justify-items-center content-center py-10",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "chart svg",
                                        src: "/img/home/start/steps_1.svg",
                                        width: 200,
                                        height: 200
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        className: "flex items-center pt-6",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                                alt: "chart svg",
                                                src: "/img/home/start/Number-One.svg",
                                                width: 50,
                                                height: 50
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                                type: "h4",
                                                color: "secondary",
                                                fontWeight: "Bold",
                                                className: "px-2",
                                                children: sections === null || sections === void 0 ? void 0 : (ref7 = sections[4]) === null || ref7 === void 0 ? void 0 : ref7.content
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "chart svg",
                                        src: "/img/home/start/steps_2.svg",
                                        width: 200,
                                        height: 200
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        className: "flex items-center pt-6",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                                alt: "chart svg",
                                                src: "/img/home/start/Number-Two.svg",
                                                width: 50,
                                                height: 50
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                                type: "h4",
                                                color: "secondary",
                                                fontWeight: "Bold",
                                                className: "px-2",
                                                children: sections === null || sections === void 0 ? void 0 : (ref8 = sections[5]) === null || ref8 === void 0 ? void 0 : ref8.content
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "chart svg",
                                        src: "/img/home/start/steps_3.svg",
                                        width: 200,
                                        height: 200
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        className: "flex items-center pt-6",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                                alt: "chart svg",
                                                src: "/img/home/start/Number-Three.svg",
                                                width: 50,
                                                height: 50
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                                type: "h4",
                                                color: "secondary",
                                                fontWeight: "Bold",
                                                className: "px-2",
                                                children: sections === null || sections === void 0 ? void 0 : (ref9 = sections[6]) === null || ref9 === void 0 ? void 0 : ref9.content
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                        backgroundColor: "secondary",
                        color: "lighterGray",
                        className: "mt-10 mx-auto",
                        onClick: function() {
                            router.push("/auth/signin");
                        },
                        children: t("begin")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
                backgroundImage: "/img/home/tradingview/home-chart-background.jpg",
                parallax: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                        color: "medGray",
                        highlightColor: "secondary",
                        highlight: "نمودار",
                        imgSrc: "/img/svg/title-line-secondary.svg",
                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                        children: sections === null || sections === void 0 ? void 0 : (ref10 = sections[7]) === null || ref10 === void 0 ? void 0 : ref10.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "grid lg:grid-cols-2 content-center pt-6",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "self-center justify-self-center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/charts",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        className: "cursor-pointer",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                            alt: "chart svg",
                                            src: "/img/home/tradingview/presentation.png",
                                            width: "600",
                                            height: "400"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "self-center justify-self-center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                        type: "div",
                                        color: "text",
                                        className: "pt-10",
                                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {text-align: center;}"),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "dynamic-content",
                                            dangerouslySetInnerHTML: {
                                                __html: sections === null || sections === void 0 ? void 0 : (ref11 = sections[7]) === null || ref11 === void 0 ? void 0 : ref11.content
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                                        backgroundColor: "secondary",
                                        color: "lighterGray",
                                        className: "mt-10 lg:mr-0 mx-auto w-40",
                                        onClick: function() {
                                            router.push("/charts");
                                        },
                                        children: t("charts")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
                backgroundImage: "/img/svg/Background-mountain.svg",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                        color: "text",
                        highlight: "چرا",
                        imgSrc: "/img/svg/title-line.svg",
                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                        children: sections === null || sections === void 0 ? void 0 : (ref12 = sections[8]) === null || ref12 === void 0 ? void 0 : ref12.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "grid md:grid-cols-2 lg:grid-cols-4 justify-items-center py-16 gap-6",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* FeatureCard */.TT, {
                                title: sections === null || sections === void 0 ? void 0 : (ref13 = sections[9]) === null || ref13 === void 0 ? void 0 : ref13.title,
                                description: sections === null || sections === void 0 ? void 0 : (ref14 = sections[9]) === null || ref14 === void 0 ? void 0 : ref14.content,
                                iconSrc: "/img/home/why-choose-us/interest-rate.svg"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* FeatureCard */.TT, {
                                title: sections === null || sections === void 0 ? void 0 : (ref15 = sections[10]) === null || ref15 === void 0 ? void 0 : ref15.title,
                                description: sections === null || sections === void 0 ? void 0 : (ref16 = sections[10]) === null || ref16 === void 0 ? void 0 : ref16.content,
                                iconSrc: "/img/home/why-choose-us/24-support.svg"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* FeatureCard */.TT, {
                                title: sections === null || sections === void 0 ? void 0 : (ref17 = sections[11]) === null || ref17 === void 0 ? void 0 : ref17.title,
                                description: sections === null || sections === void 0 ? void 0 : (ref18 = sections[11]) === null || ref18 === void 0 ? void 0 : ref18.content,
                                iconSrc: "/img/home/why-choose-us/forex-icon.svg"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* FeatureCard */.TT, {
                                title: sections === null || sections === void 0 ? void 0 : (ref19 = sections[12]) === null || ref19 === void 0 ? void 0 : ref19.title,
                                description: sections === null || sections === void 0 ? void 0 : (ref20 = sections[12]) === null || ref20 === void 0 ? void 0 : ref20.content,
                                iconSrc: "/img/home/why-choose-us/wallet.svg"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
                backgroundColor: "primary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                        color: "medGray",
                        highlightColor: "secondary",
                        highlight: "پرداخت",
                        imgSrc: "/img/svg/title-line-secondary.svg",
                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                        children: sections === null || sections === void 0 ? void 0 : (ref21 = sections[13]) === null || ref21 === void 0 ? void 0 : ref21.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "grid lg:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                type: "p",
                                color: "text",
                                className: "pt-10 lg:max-w-sm 2xl:mr-24",
                                style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {text-align: center; margin-bottom: 2rem;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "dynamic-content",
                                    dangerouslySetInnerHTML: {
                                        __html: sections === null || sections === void 0 ? void 0 : (ref22 = sections[13]) === null || ref22 === void 0 ? void 0 : ref22.content
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "flex justify-evenly",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* PartnerLogo */.EX, {
                                        imageSrc: "/img/home/pay/paypal.svg",
                                        caption: "paypal"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* PartnerLogo */.EX, {
                                        imageSrc: "/img/home/pay/tether-usdt-logo.svg",
                                        caption: "tether"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
                backgroundImage: "/img/home/brokers/our-brokers-background.png",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                        color: "text",
                        highlight: t("brokers"),
                        imgSrc: "/img/svg/title-line.svg",
                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                        children: t("list of brokers")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "grid lg:grid-cols-2 py-16 gap-4 xl:gap-10",
                        children: brokers === null || brokers === void 0 ? void 0 : brokers.map(function(b) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage/* BrokerCard */.Uo, {
                                broker: b
                            }, b.id);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Button */.zx, {
                        backgroundColor: "primary",
                        color: "secondary",
                        className: "w-40 mx-auto",
                        onClick: function() {
                            router.push("/brokers");
                        },
                        children: t("all brokers")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Section */.$0, {
                backgroundImage: "/img/home/faq/home-faq-background.jpg",
                parallax: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Title */.Dx, {
                        color: "lighterGray",
                        highlight: "پرسش های",
                        imgSrc: "/img/svg/title-line.svg",
                        style: "".concat((0,Utility/* MediaQuery */.zP)("md", "max"), " {justify-content: center; .typography{text-align: center;};}"),
                        children: sections === null || sections === void 0 ? void 0 : (ref23 = sections[14]) === null || ref23 === void 0 ? void 0 : ref23.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "grid justify-items-start pt-10 xl:gap-10",
                        children: sections === null || sections === void 0 ? void 0 : sections.slice(15).filter(function(s) {
                            return s === null || s === void 0 ? void 0 : s.content;
                        }).map(function(s, i) {
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "flex w-full mt-6 lg:mt-0",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "pr-6 w-full",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Accordion */.UQ, {
                                        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                                    alt: "",
                                                    src: "/img/svg/check.svg",
                                                    width: 38,
                                                    height: 38
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                                    type: "h4",
                                                    color: "lighterGray",
                                                    style: "margin: 0 10px;",
                                                    children: s === null || s === void 0 ? void 0 : s.title
                                                })
                                            ]
                                        }),
                                        content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorTypography/* default */.Z, {
                                            type: "p",
                                            color: "lightGray",
                                            className: "pt-2 xl:px-14",
                                            align: "justify",
                                            children: s === null || s === void 0 ? void 0 : s.content
                                        })
                                    })
                                })
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {
                width: "100%",
                spacer: "none",
                depth: "5px",
                withGradient: true
            })
        ]
    });
}
Homepage.Layout = Layout/* Layout */.A;
var __N_SSG = true;
/* harmony default export */ var pages = (Homepage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,980,13,955,866,914,131,258,533,824,879,774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);